export default {
  brandColor1: '#025B63',
  complimentaryColor1: '#fff',
  brandColor2: '#41C2E1',
  complimentaryColor2: '#fff',
};
